<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md4
      >
        <material-card class="v-card-profile">
          <v-avatar
            slot="offset"
            class="mx-auto d-block"
            size="140"
          >
            <img src="@/../public/img/logo2.png">

          </v-avatar>
          <v-card-text class="text-xs-center">
            <!-- <h6 class="category text-gray font-weight-thin mb-3">エンジニア</h6> -->
            <h4 class="card-title font-weight-light">かきそふと</h4>
            <p class="card-description font-weight-light">
              「賢者は歴史に学び、愚か者は経験に学ぶ」という格言があるが、経験から学ぶ事が何よりも重要だと思う。<br>
              <br>
              私は経験に学ぶ愚か者でいい。
            </p>
            <!-- <v-btn
              color="success"
              round
              class="font-weight-light"
            >何言ってんのお前？</v-btn> -->

            <v-tooltip
              top
              content-class="top">
              <v-btn
                slot="activator"
                class="v-btn--simple"
                color="success"
              >
                <v-btn
                  color="success"
                  round
                  class="font-weight-light"
                >何言ってんのお前？</v-btn>
              </v-btn>
              <span>ごめん。押しても何も起きないんだ。</span>
            </v-tooltip>

          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  //
}
</script>
